import React, { createContext, useContext, useState } from "react";

interface UpgradeContextType {
  isUpgrading: boolean;
  setIsUpgrading: (value: boolean) => void;
}

const UpgradeContext = createContext<UpgradeContextType | undefined>(undefined);

export const UpgradeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isUpgrading, setIsUpgrading] = useState(false);

  return (
    <UpgradeContext.Provider value={{ isUpgrading, setIsUpgrading }}>
      {children}
    </UpgradeContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useUpgrade = () => {
  const context = useContext(UpgradeContext);
  if (context === undefined) {
    throw new Error("useUpgrade must be used within an UpgradeProvider");
  }
  return context;
};
